import { render, staticRenderFns } from "./ItemCol.vue?vue&type=template&id=13443e65&scoped=true&"
import script from "./ItemCol.vue?vue&type=script&lang=js&"
export * from "./ItemCol.vue?vue&type=script&lang=js&"
import style0 from "./ItemCol.vue?vue&type=style&index=0&id=13443e65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13443e65",
  null
  
)

export default component.exports